import { useNavigate } from 'react-router-dom';
import React from 'react'; // Import React to use React.ChangeEvent

const Mainpage_certificate = () => {
    const navigate = useNavigate();
    
    // Function to handle dropdown change
    const handleCourseChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedCourse = event.target.value;
        if (selectedCourse) {
            navigate(`/generate-certificate/${selectedCourse}`);
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-50 to-blue-100">
            {/* Header Section */}
            <header className="text-center mb-10">
                <h1 className="text-6xl font-bold text-gray-800 mb-6">
                    Welcome to the Certificate Generator
                </h1>
                <p className="text-lg text-gray-600">
                    Generate Azure, Python, SQL certificates with ease.
                </p>
                <button 
                    className='bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-10 text-xl'
                    onClick={() => navigate('/generate-certificate/certificate-data')} // Button click for direct navigation
                >
                    Certificate Data
                </button>
            </header>

            {/* Dropdown for Course Selection */}
            <div className="flex flex-col items-center mb-16 space-y-6 max-w-md">
                <select
                    onChange={handleCourseChange}
                    className="w-full bg-white border border-gray-300 text-gray-700 py-3 px-4 rounded-xl text-lg shadow-md focus:outline-none focus:border-blue-500 transform transition-all duration-300 hover:scale-105"
                >
                    <option value="">Select a course</option>
                    <option value="Azure">Generate Azure Certificate</option>
                    <option value="Python">Generate Python Certificate</option>
                    <option value="SQL">Generate SQL Certificate</option>
                </select>
            </div>
        </div>
    );
};

export default Mainpage_certificate;